import { createRovoOpsSpotlightPlacement } from './create-rovo-ops-spotlight-placement';

export const ROVO_OPS_GROUP_DETAIL_SELECTOR = '#rovo-ops-cta-panel-spotlight-target';

const rovoOpsGroupDetailSpotlightPlacement: ReturnType<typeof createRovoOpsSpotlightPlacement> =
	createRovoOpsSpotlightPlacement({
		placementId: 'rovo-ops-group-detail-spotlight',
		selector: ROVO_OPS_GROUP_DETAIL_SELECTOR,
		popoverPlacement: 'left-start',
	});

export const MessageFrontend: typeof rovoOpsGroupDetailSpotlightPlacement.MessageFrontend =
	rovoOpsGroupDetailSpotlightPlacement.MessageFrontend;

export const PlacementFrontend: typeof rovoOpsGroupDetailSpotlightPlacement.PlacementFrontend =
	rovoOpsGroupDetailSpotlightPlacement.PlacementFrontend;
